import axios from 'axios';
const REQUEST_TIMEOUT_MS = 60000 * 10; // 10 mins
const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
/**
 * Create a new Axios instance with a custom config.
 */
export const axiosInstance = axios.create({
    responseType: 'json',
    timeout: REQUEST_TIMEOUT_MS,
    headers: { ...defaultHeaders },
    timeoutErrorMessage: 'Request timeout error',
    validateStatus: (status) => status < 400
});
/**
 * Update required header of the Axios instance
 */
export const updateAuthAxiosHeader = (token) => {
    axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
};
/**
 * Set the base URL prepended to every relative request URL.
 * Web leaves this unset so requests stay relative and go through the Vite proxy;
 * mobile sets it to the API host since it has no proxy.
 */
export const updateAxiosBaseUrl = (baseUrl) => {
    axiosInstance.defaults.baseURL = baseUrl;
};
export const updateAxiosHandlers = (callback401, callback404, callback503) => {
    axiosInstance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response.status === 401) {
            callback401();
        }
        else if (error.response.status === 404) {
            callback404();
        }
        else if (error.response.status === 503) {
            callback503();
        }
        throw error;
    });
};
//# sourceMappingURL=request.js.map